export default "__VITE_ASSET__Cb4GwYJS__"